// extracted by mini-css-extract-plugin
export default {"countrySwitch":"CountrySwitch_countrySwitch__X1ITx","flagIcon":"CountrySwitch_flagIcon__45l7Z","countryOption":"CountrySwitch_countryOption__FihIH"};